module.exports = __webpack_public_path__ + "img/copy.927ec6a6.svg";